import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { NavigationError, provideRouter, withDebugTracing, withNavigationErrorHandler } from '@angular/router';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { LoggerModule } from 'ngx-logger';
import { ENVIRONMENT } from '../../../libs/models/src/lib/injection.tokens';
import { ModalModule } from 'ngx-bootstrap/modal';
import { bearerTokenHeaderInterceptor } from '../../../libs/services/src/lib/auth/bearer-token-header-interceptor';
import { refreshTokenInterceptor } from '../../../libs/services/src/lib/auth/refresh-token-interceptor';
import { AUTH_SVC, AuthService } from '@company-box/services';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withNavigationErrorHandler((error: NavigationError) => {
        // Handle the error, e.g., redirect to an error page
        console.error("Navigation error occurred:", error);
        return "/login"; // Redirect to the error route
      })
    ),
    // provideRouter(routes, withDebugTracing()),
    provideHttpClient(withInterceptors([bearerTokenHeaderInterceptor, refreshTokenInterceptor])),
    importProvidersFrom([
      BrowserAnimationsModule,
      LoggerModule.forRoot({
        serverLoggingUrl: environment.logger.serverLoggingUrl,
        level: environment.logger.logLevel,
        serverLogLevel: environment.logger.serverLogLevel,
      }),
      ModalModule.forRoot(),
      PopoverModule.forRoot(),
      BsDropdownModule.forRoot(),
    ]),
    provideAnimations(),
    { provide: ENVIRONMENT, useValue: environment },
    { provide: AUTH_SVC, useClass: AuthService },
  ],
};
